import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import Alert from '../../components/Alert'
import { IoIosSearch } from 'react-icons/io';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import axiosClient from '../../axios-client';
import { useStateContext } from '../../contexts/ContextProvider';
import { toast } from 'react-toastify';
import Loading from '../../components/Loading';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaRegFileExcel } from 'react-icons/fa6';
import { LuFileSpreadsheet } from 'react-icons/lu';
import Swal from 'sweetalert2';
import MySelect from '../../components/MySelect';

const EtatMensuelEcole = () => {
    const [errors, setErrors] = useState(null);
    const [items, setItems] = useState([]);
    const [inputValue, setValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);
    const [loading, setLoading] = useState(false);
    const [factures, setFactures] = useState([]);

    const { token, setToken, user } = useStateContext();
    const tableRef = useRef();
    const [type, setType] = useState('');
    const [classes, setClasses] = useState([]);
    const [selectedClasse, setSelectedClasse] = useState(null);
    const [inputValueClasse, setValueClasse] = useState('');
    const [somme, setSomme] = useState({
        totalRest: 0,
        totalPayee: 0,


    })
    const [req, setReq] = useState({
        'mois': 0,
        'classe': ''
    });
    const navigate = useNavigate();
    const getClasses = () => {
        axiosClient.get('/classes')
            .then((data) => {
                setClasses(data.data.classes);
            }).catch(err => {
                navigate('/500');
            })
    }

    const handleInputChangeClasse = value => {
        setValueClasse(value);
    };
    const handleChangeClasse = value => {
        setSelectedClasse(value);
        setReq({ ...req, classe: value.id });

    }
    // handle input change event

    const handleInputChange = value => {
        setValue(value);
    };

    // handle selection
    const handleChange = value => {
        setSelectedValue(value);
        setReq({ ...req, mois: value.id })

    }

    useEffect(() => {
        getMois();
        getClasses();
    }, []);



    const getMois = () => {
        axiosClient.get('/mois-scolaires')
            .then((data) => {
                setItems(data.data.mois);
            })
    }



    const getFacture = () => {

        setLoading(true);
        if (selectedValue != null) {
            axiosClient.get('/etatMensuelEcole/' + req.mois)
                .then(response => {
                    setFactures(response.data.etat);

                    setLoading(false);
                    setErrors(null);
                }).catch(err => {
                    const response = err.response;
                    if (response.status === 401) {
                        setToken(null);
                    }
                    else {
                        if (response.status === 422) {
                            setErrors(response.data.errors);
                            setLoading(false);
                            toast.error('Merci de verifier les informations a saisies!', {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        } else {
                            if (response.status === 403) {
                                navigate('/403');
                            } else {
                                if (response.status === 404) {
                                    navigate('/404');
                                }
                                else {
                                    navigate('/500');
                                }
                            }
                        }

                    }
                })
        } else {

        }

    }




    return (
        <>
            <Header icon={<LuFileSpreadsheet />} title="Etat Mensuel de Classe" />
            {errors &&
                Object.keys(errors).map(key => (
                    <Alert key={key} message={errors[key][0]} />
                ))
            }
            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between items-center'>

                <div className='mt-8 flex w-full gap-2' >
                    <div className=' w-full'>
                        <MySelect label="Mois Scolaire" placeholder="Mois scolaire" cacheOptions defaultOptions value={selectedValue} getOptionLabel={e => e.libelle} getOptionValue={e => e.id} options={items} onInputChange={handleInputChange} onChange={handleChange} />
                    </div>
                    <div className="flex w-full gap-2">
                        
                        <div className="mt-8">
                            <Button onClick={() => getFacture()} color="bg-yellow-500" icon={<IoIosSearch />} text="Chercher" textColor="text-white" />
                        </div>
                    </div>

                    <DownloadTableExcel
                        filename="Factures"
                        sheet="Factures"
                        currentTableRef={tableRef.current}
                    >
                        <Button color="bg-green-500" icon={<FaRegFileExcel />} size="20" text="Exporter" textColor="text-white" />

                    </DownloadTableExcel>
                </div>
            </div>

            <div className='flex gap-2 w-full flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap '>



            </div>
            <div className="flex my-2 gap-3">
                <h1 className='text-red-500 font-bold'>Total Reste: {factures.reduce((n, { nonPaye }) => n + parseFloat(nonPaye), 0)} MRU</h1>
                <h1 className='text-green-700 font-bold'>Total Payée: {factures.reduce((n, f) => n + (parseFloat(f.montant) - parseFloat(f.nonPaye)), 0)} MRU</h1>
            </div>
            <div className='flex mt-3 overflow-auto'>

                <table ref={tableRef} className='table-auto' >
                    <thead>
                        <tr>
                            <th>Matricule</th>
                            <th>Eleve</th>
                            <th>Tel Parent</th>
                            <th>Classe</th>
                            <th>Mois</th>
                            <th>Montant</th>
                            <th>Paye</th>
                            <th>Reste</th>
                        </tr>
                    </thead>
                    {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="9"><Loading /></td></tr></tbody> :
                        <tbody>
                            {factures && factures.map(o => (
                                <tr className={o.nonPaye>0 ? 'bg-red-400 hover:bg-red-200' : ' hover:bg-gray-200'} key={o.id}>
                                    <td>{o.matricule}</td>
                                    <td>{o.eleve}</td>
                                    <td>{o.telParent}</td>
                                    <td>{o.classe}</td>
                                    <td>{o.mois}</td>
                                    <td>{o.montant}</td>
                                    <td>{o.montant-o.nonPaye}</td>
                                    <td>{o.nonPaye}</td> 
                                </tr>
                            ))

                            }
                        </tbody>

                    }

                </table>

            </div>

        </>
    )
}

export default EtatMensuelEcole